import Countdown from 'react-countdown';

import NotificationBanner from './NotificationBanner';

export const XTERIO_CLAIM_END_DATE = new Date('2025-05-02');

export default function Notifications() {
  return (
    <>
      {/* <NotificationBanner
        handleClick={() => setConvertReAltDialogOpen(true)}
        localStorageKey="notification.autocompound.dismissed"
        message="Save gas fees with auto-compound. Convert your stALT to reALT now!"
      /> */}

      {/* <NotificationBanner
        handleClick={() =>
          navigate(
            paths.EigenRewards.replace(':airdropKey', 'eigen').replace(
              ':chainId',
              supportedEthChainId ? String(supportedEthChainId) : ''
            )
          )
        }
        localStorageKey="notification.eigen.dismissed"
        message="EIGEN Drop claim is live! Check if you are eligible now!"
        sx={{
          '&& .MuiPaper-root': {
            background: 'linear-gradient(103deg, #C393FF 0%, #A281FF 100%)',
          },
        }}
      /> */}

      {Date.now() < XTERIO_CLAIM_END_DATE.getTime() + 1000 * 60 * 60 * 24 && ( // Continue to show notification for up to 24 hour after it ends. After that, hide it.
        <NotificationBanner
          dismissOnCloseOnly
          handleClick={() =>
            window.open('https://x.com/XterioGames/status/1915324633638986136', '_blank')
          }
          // localStorageKey="notification.xter-tranche-1.dismissed"
          localStorageKey="" // reopen if page is refreshed, do not keep track of dismissed
          message={
            <Countdown
              date={XTERIO_CLAIM_END_DATE}
              renderer={({ completed, days, hours, minutes, seconds }) => {
                const dayStr = days ? `${days}d:` : '';
                const hourStr = hours || days ? `${hours}h:` : '';
                const minStr = hours || days || minutes ? `${minutes}m:` : '';
                const secStr = `${seconds}s`;
                const timeStr = [dayStr, hourStr, minStr, secStr].join('');

                return completed
                  ? 'Tranche #1 of XTER claims has ended'
                  : `Tranche #1 of XTER claims is now live! (Ending in ${timeStr})`;
              }}
            />
          }
        />
      )}
    </>
  );
}
